/* __next_internal_client_entry_do_not_use__ Link auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1670))
 * @trackcomponent
 * @lastsynced 2023-08-29T19:36:17.781Z
 */ export var Link = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M10.3574 5.42857L12.7626 3.02343C13.8578 1.9632 15.3259 1.37594 16.8502 1.38831C18.3745 1.40069 19.8328 2.01171 20.9107 3.08958C21.9886 4.16746 22.5996 5.62581 22.612 7.1501C22.6243 8.6744 22.0371 10.1425 20.9769 11.2377L18.5717 13.6429",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M13.6429 18.5714L11.2378 20.9766C10.1425 22.0368 8.67446 22.6241 7.15017 22.6117C5.62587 22.5993 4.16752 21.9883 3.08964 20.9104C2.01177 19.8325 1.40075 18.3742 1.38838 16.8499C1.376 15.3256 1.96326 13.8575 3.02349 12.7623L5.42863 10.3571",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M15.2858 8.71429L8.71436 15.2857",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Link", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "8j4fBL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Link to"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
